import baseApi from '../utils/ApiUtils';

export const taskPoolServices= (method, id, payload = null, params = null) => {
  return baseApi(`/task_pools/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const activityLogService= (method, id, payload = null, params = null) => {
  return baseApi(`/task_pools/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const catalogueActivityLogService= (method, id, payload = null, params = null) => {
  return baseApi(`/catalogues/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const acquisitionActivityLogService= (method, id, payload = null, params = null) => {
  return baseApi(`/acquisitions/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};